<p-dialog header="{{ 'ImportDeclarationCostReview.CostReview' | translate }}" [(visible)]="display" appendTo="body"
  (onHide)="hideDialog($event)" [modal]="true" [style]="{'width': '80vw'}">
  <div class="p-fluid formgrid grid">
    <div class="col-12 md:col-6 lg:col-4 mb-3">
      <label>{{ 'ImportDeclarationCostReview.DocumentNum' | translate }} :
        {{this.bookingNo}}</label>
    </div>
    <div class="col-12 md:col-6 lg:col-4 mb-3">
      <label>{{ 'ImportDeclarationCostReview.DocumentType' | translate }} :
        {{this.billingView?.billing?.billingType}}</label>
    </div>
    <div class="col-12 md:col-6 lg:col-4 mb-3">
      <label>{{ 'ImportDeclarationCostReview.Forwarder' | translate }} :
        {{ this.billingView?.billing?.forwarderCode | optionsMapping: forwarderOptionList }}</label>
    </div>
    <div class="col-12 md:col-6 lg:col-4 mb-3">
      <label>{{ 'ImportDeclarationCostReview.Company' | translate }} :
        {{this.billingView?.billing?.billCorp}}</label>
    </div>
    <div class="col-12 md:col-6 lg:col-4 mb-3">
      <label>{{ 'ImportDeclarationCostReview.AccountingCurrency' | translate }} :
        {{this.billingView?.billing?.currency}}</label>
    </div>
    <div class="col-12 md:col-6 lg:col-4 mb-3">
      <label>{{ 'ImportDeclarationCostReview.EstimateTotalAnt' | translate }} :
        {{this.billingView?.billing?.estimateTotalCharge}}</label>
    </div>
    <div class="col-12 md:col-6 lg:col-4 mb-3">
      <label>{{ 'ImportDeclarationCostReview.AWBNum' | translate }} :
        {{this.billingView?.billing?.expressBill}}</label>
    </div>
  </div>

  <div>
    <p-table [value]="this.billingView?.billingViewerDetails" [columns]="columns" dataKey="billingDetail.seqNo"
      [scrollable]="true" [resizableColumns]="true" class="edittable" [loading]="isLoading">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="text-align:center">
            <div *ngIf="isShowAddBillingBtn && isShowNew; else noShowNew">
              <button pButton type="button" icon="pi pi-plus" class="ui-button-info" (click)="onRowNew()"></button>
            </div>
            <ng-template #noShowNew>

            </ng-template>
          </th>
          <th *ngFor="let col of columns">
            {{col.header | translate}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rows let-columns="columns" let-ri="rowIndex">
        <tr>
          <td style="text-align:center">
            <div *ngIf="isShowDeleteBillingBtn && rows.billingDetail?.billingStatus === 'WATTING_TO_PROCESSS'">
              <button pButton type="button" icon="pi pi-minus" class="p-button-danger"
                (click)="onRowDelete(ri, $event)"></button>
            </div>
          </td>

          <!--RfqFeeType-->
          <!-- <td>
            <div *ngIf="(rows.billingDetail?.seqNo != 0); else editRfqFeeType">
              {{rows.billingDetail?.rfqFeeType}}
            </div>
          </td>
          <ng-template #editRfqFeeType>
            <p-cellEditor>
              <ng-template pTemplate="input">
                {{rows.billingDetail.feeType}}
              </ng-template>
              <ng-template pTemplate="output">
                {{rows.billingDetail.feeType}}
              </ng-template>
            </p-cellEditor>
          </ng-template> -->
          <td>
            <div>
              {{rows.billingDetail?.rfqFeeType}}
            </div>
          </td>

          <!--AccountCode-->
          <td>
            <div *ngIf="(rows.billingDetail?.seqNo != 0); else editAccountCode">
              {{
              rows.billingDetail?.accountCode
              | optionsMapping: this.accountCodes
              | replaceNullWith: "-"
              }}
            </div>
          </td>
          <ng-template #editAccountCode>
            <p-dropdown [options]="accountCodes" [(ngModel)]="rows.billingDetail.accountCode" appendTo="body"
              [itemSize]="100" placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
            </p-dropdown>
          </ng-template>

          <!--EstimatedAmountDesc-->
          <td>
            <div *ngIf="(rows.billingDetail?.seqNo != 0); else editEstimatedAmountDesc">
              {{rows.billingDetail?.estimatedAmountDesc}}
            </div>
          </td>
          <ng-template #editEstimatedAmountDesc>
            <input pInputText type="text" [(ngModel)]="rows.billingDetail.estimatedAmountDesc">
          </ng-template>

          <!--EstimatedAmount-->
          <td>
            <div *ngIf="(rows.billingDetail?.seqNo != 0); else editEstimatedAmount">
              {{rows.billingDetail?.estimatedAmount}}
            </div>
          </td>
          <ng-template #editEstimatedAmount>
            <p-inputNumber [minFractionDigits]="2" [maxFractionDigits]="2"
              [class]="showValidationMessage(rows.billingDetail.estimatedAmount) ? ['ng-invalid', 'ng-dirty'] : []"
              mode="decimal" [(ngModel)]="rows.billingDetail.estimatedAmount"
              (onInput)="handleEstimatedAmountChange($event, ri)"
              ></p-inputNumber>
          </ng-template>

          <!--PreCurrencyCode-->
          <td>
            <div *ngIf="(rows.billingDetail?.seqNo != 0); else editPreCurrencyCode">
              {{rows.billingDetail?.preCurrencyCode}}
            </div>
          </td>
          <ng-template #editPreCurrencyCode>
            <p-dropdown [options]="currencyOptions" [(ngModel)]="rows.billingDetail.preCurrencyCode" appendTo="body"
              [class]="showValidationMessage(rows.billingDetail.preCurrencyCode) ? ['ng-invalid', 'ng-dirty'] : []"
              (onChange)="onEditRowCurrencyChange($event, ri)" [itemSize]="100"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
            </p-dropdown>
          </ng-template>

          <!--Rate-->
          <td>{{rows.billingDetail?.rate}}</td>

          <!--LinePayAmount-->
          <td>{{rows.billingDetail?.linePayAmount | replaceNullWith: "-"}} </td>

          <!--BillingStatus-->
          <td>{{rows.billingDetail?.billingStatus}}</td>

          <!--BillType-->
          <td>
            <div *ngIf="(rows.billingDetail?.seqNo != 0); else editBillType">
              {{
              rows.billingDetail?.billType
              | optionsMapping: this.billTypeOptions
              | replaceNullWith: "-"
              }}
            </div>
          </td>
          <ng-template #editBillType>
            <p-dropdown [options]="this.billTypeOptions" [(ngModel)]="rows.billingDetail.billType" appendTo="body"
              [itemSize]="100" placeholder="{{ 'Common.DropDown.Select' | translate }}">
            </p-dropdown>
          </ng-template>

          <!--CarrierPaymentBy-->
          <td>
            <div *ngIf="(rows.billingDetail?.seqNo != 0); else editCarrierPaymentBy">
              {{
              rows.billingDetail?.carrierPaymentBy
              | optionsMapping: this.carrierPaymentByOptions
              | replaceNullWith: "-"
              }}
            </div>
          </td>
          <ng-template #editCarrierPaymentBy>
            <p-dropdown [options]="this.carrierPaymentByOptions" [(ngModel)]="rows.billingDetail.carrierPaymentBy"
              appendTo="body" [itemSize]="100"
              placeholder="{{ 'Common.DropDown.Select' | translate }}">
            </p-dropdown>
          </ng-template>

          <!--GuiNo-->
          <td>
            <div *ngIf="(rows.billingDetail?.seqNo != 0); else editGuiNo">
              {{rows.billingDetail?.guiNo}}
            </div>
          </td>
          <ng-template #editGuiNo>
            <input pInputText type="text" required [(ngModel)]="rows.billingDetail.guiNo"/>
          </ng-template>

          <!--GuiCurrency-->
          <td>
            <div *ngIf="(rows.billingDetail?.seqNo != 0); else editGuiCurrency">
              {{rows.billingDetail?.guiCurrency}}
            </div>
          </td>
          <ng-template #editGuiCurrency>
            <p-dropdown [options]="this.currencyOptions" [(ngModel)]="rows.billingDetail.guiCurrency" appendTo="body"
              [itemSize]="100" placeholder="{{ 'Common.DropDown.Select' | translate }}">
            </p-dropdown>
          </ng-template>

          <!--GuiAmount-->
          <td>
            <div *ngIf="(rows.billingDetail?.seqNo != 0); else editGuiAmount">
              {{
              rows.billingDetail?.guiAmount
              | number: "1.4-4"
              | replaceNullWith: "-"}}
            </div>
          </td>
          <ng-template #editGuiAmount>
            <p-inputNumber mode="decimal" [minFractionDigits]="4" [(ngModel)]="rows.billingDetail.guiAmount" >
            </p-inputNumber>
          </ng-template>

          <!--InvoiceType-->
          <td>
            <div *ngIf="(rows.billingDetail?.seqNo != 0); else editInvoiceType">
              {{rows.billingDetail?.invoiceType
              | optionsMapping: this.invoiceTypeOptions
              | replaceNullWith: "-"}}
            </div>
          </td>
          <ng-template #editInvoiceType>
            <p-dropdown [options]="this.invoiceTypeOptions" [(ngModel)]="rows.billingDetail.invoiceType" appendTo="body"
              [itemSize]="100" placeholder="{{ 'Common.DropDown.Select' | translate }}">
            </p-dropdown>
          </ng-template>

          <!--GuiDt-->
          <td>
            <div *ngIf="(rows.billingDetail?.seqNo != 0); else editGuiDt">
              {{rows.billingDetail?.guiDt | date
              : "yyyy-MM-dd HH:mm"
              : this.laasSetting.facilityTimeZone
              | replaceNullWith: "-"}}
            </div>
          </td>
          <ng-template #editGuiDt>
            <p-calendar appendTo="body" dateFormat="yy-mm-dd" [showTime]="true" [(ngModel)]="rows.billingDetail.guiDt" [maxDate]="today">
            </p-calendar>
          </ng-template>

          <!--PaymentMethod-->
          <td>
            <div *ngIf="(rows.billingDetail?.seqNo != 0); else editPaymentMethod">
              {{rows.billingDetail?.paymentMethod
              | optionsMapping: this.paymentMethodOptions
              | replaceNullWith: "-"}}
            </div>
          </td>
          <ng-template #editPaymentMethod>
            <p-dropdown [options]="this.paymentMethodOptions" [(ngModel)]="rows.billingDetail.paymentMethod"
              appendTo="body" [itemSize]="100"
              placeholder="{{ 'Common.DropDown.Select' | translate }}">
            </p-dropdown>
          </ng-template>

          <!--TermsId-->
          <td>
            <div *ngIf="(rows.billingDetail?.seqNo != 0); else editTermsId">
              {{rows.billingDetail?.termsId
              | optionsMapping: this.termsIdOptions
              | replaceNullWith: "-"}}
            </div>
          </td>
          <ng-template #editTermsId>
            <p-dropdown [options]="this.termsIdOptions" [(ngModel)]="rows.billingDetail.termsId" appendTo="body"
              [itemSize]="100" placeholder="{{ 'Common.DropDown.Select' | translate }}">
            </p-dropdown>
          </ng-template>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div *ngIf="isShowAddBillingBtn || isShowDeleteBillingBtn">
    <button pButton pRipple label="{{ 'Common.Button.Save' | translate }}" (click)="saveBtnClick()"></button>
  </div>
</p-dialog>
